import * as Sentry from '@sentry/react';
import { ServerErrorPage } from '@/shared/ui/brand-status';

interface ResetFallbackProps {
  resetError: () => void;
}

function ResetFallback({ resetError }: ResetFallbackProps): JSX.Element {
  return <ServerErrorPage layout="viewport" onRetry={resetError} />;
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <Sentry.ErrorBoundary fallback={(props) => <ResetFallback resetError={props.resetError} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
